import { type RequestBody } from '../http/type-helpers';

import { USER_EDUCATION_VIEW_COUNTS_ENDPOINT } from '@/constants/endpoints';
import { typedHttp } from '@/modules/http';

export function fetchUserEducationViewCounts() {
  return typedHttp.get(USER_EDUCATION_VIEW_COUNTS_ENDPOINT, {
    withAuth: true,
  });
}

export function updateUserEducationViewCounts(
  updatedViewCounts: RequestBody<typeof USER_EDUCATION_VIEW_COUNTS_ENDPOINT>
) {
  return typedHttp.post(
    USER_EDUCATION_VIEW_COUNTS_ENDPOINT,
    updatedViewCounts,
    {
      withAuth: true,
    }
  );
}
